module.exports = __webpack_public_path__ + "static/media/bunny.cc74b43c.jpg";